import { DEFAULT_COUNTRY } from './const';

const identity = state => state.identity;
const countries = state => state.countries;

const getDefaultCountry = state => state.countries.find(country => country.alpha_2 === DEFAULT_COUNTRY);
const getIdentificationType = state => state.identification.type;

const isAwaitingModification = state => state.identification.status === 'AWAITING_MODIFICATION';
const isApproved = state => state.identification.status === 'APPROVED';

export default {
  identity,
  countries,
  getDefaultCountry,
  getIdentificationType,
  isAwaitingModification,
  isApproved,
};
